module.exports = __webpack_public_path__ + "img/related-post-03.b4bc7805.jpg";